import { createApp } from 'vue'

import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { md3 } from 'vuetify/blueprints'
import colors from 'vuetify/util/colors'

import OxApp from "./components/OxApp.vue"


window.addEventListener("load", () => {
    const app = createApp(OxApp, {
        logo: "./theme/imgs/logo.png",
        content: document.getElementById('app').innerHTML,
        ...window.appProps
       
    })


    const vuetify = createVuetify({
        blueprint: md3,
        theme: {
            themes: {
                light: {
                    dark: false,
                    colors: {
                        primary: colors.green.darken1,
                        secondary: colors.green.lighten4
                    }
                }
            }
        },
        defaults: {
            VTextField: { variant: 'underlined', },
            VSelect: { variant: 'underlined', },
            VTextarea: { variant: 'outlined', },
            VCombobox: { variant: 'underlined', },
            VAutocomplete: { variant: 'underlined', },
        },
    })
    app.use(vuetify).mount('#app')
    document.getElementById("loading-overlay").classList.add("hidden")
})

